import { MatchData } from "@/interfaces/liveGamesType";
import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const fetchGetLiveMatches = (
  options?: Partial<UseQueryOptions<MatchData[]>>,
  isAuth?: boolean
) => {
  const response = useQuery({
    queryKey: ["/football/getLiveMatches", isAuth],
    queryFn: async () => {
      console.log('🔄 Atualizando partidas ao vivo...', new Date().toLocaleTimeString());
      if (isAuth) {
        const res = await api.get(`/football/getLiveMatches`);
        console.log('✅ Partidas ao vivo atualizadas (auth):', res.data.data?.length || 0);
        return res.data.data || [];
      }
      const res = await api.get("/football/getLiveMatchesFree");
      console.log('✅ Partidas ao vivo atualizadas (free):', res.data.data?.length || 0);
      return res.data.data || [];
    },
    // Configurações padrão para partidas ao vivo
    refetchInterval: 60000, // 1 minuto
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    staleTime: 30000, // 30 segundos
    cacheTime: 5 * 60 * 1000, // 5 minutos
    ...options,
  });

  return {
    ...response,
    data: response.data || []
  };
};
